import { AppointmentTooltip } from "@devexpress/dx-react-scheduler-material-ui"
import calendarStyles from "../../../styles/EventsCalendarStyles"
import { useTheme } from '@mui/material/styles'
import { useMemo } from "react"

export const LayoutTooltip = (props: any) => {
  const theme = useTheme()
  const classes = useMemo(
    () =>
      calendarStyles(theme, {
        top: 0,
        shadedHeight: 0,
        backgroundColor: '',
        color: ''
      }),
    [theme]
  )
  return <AppointmentTooltip.Layout {...props} sx={classes.layoutTooltip} />
}
